<a class="ac-link">
    <ng-content></ng-content>
</a>
